import React from 'react';
import { useTheme } from '../../hooks/useTheme';
import { FeatureItem } from '../../types';

interface FeatureGridProps {
  items: FeatureItem[];
  columns?: 2 | 3 | 4;
  className?: string;
}

export const FeatureGrid: React.FC<FeatureGridProps> = ({
  items,
  columns = 3,
  className = ''
}) => {
  const { getTextClass, getBackgroundClass, getBorderClass } = useTheme();

  const getGridCols = () => {
    switch (columns) {
      case 2: return 'grid-cols-1 md:grid-cols-2';
      case 3: return 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3';
      case 4: return 'grid-cols-1 md:grid-cols-2 lg:grid-cols-4';
      default: return 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3';
    }
  };

  return (
    <div className={`grid ${getGridCols()} gap-8 ${className}`}>
      {items.map((item) => (
        <div
          key={item.id}
          className={`p-8 rounded-2xl ${getBackgroundClass('card')} ${getBorderClass('subtle')} border transition-all duration-300 hover:scale-105 hover:shadow-xl`}
        >
          <div className="text-5xl mb-6 text-center">
            {item.icon}
          </div>
          <h3 className={`text-xl font-bold mb-4 text-center ${getTextClass('primary')}`}>
            {item.title}
          </h3>
          <p className={`text-center leading-relaxed ${getTextClass('secondary')}`}>
            {item.description}
          </p>
        </div>
      ))}
    </div>
  );
};